import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("suitor_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const streamChat = async (sessionId, text, onDelta, onDone, onError) => {
  const token = localStorage.getItem("suitor_token");
  try {
    const res = await fetch(`${API}/chat/sessions/${sessionId}/message`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ text }),
    });
    if (!res.ok || !res.body) {
      onError && onError(new Error(`HTTP ${res.status}`));
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop();
      for (const p of parts) {
        if (!p.trim()) continue;
        const raw = p.replace(/^\s*data:\s?/, "");
        if (raw === "[DONE]") {
          onDone && onDone();
          return;
        }
        let content;
        try {
          content = JSON.parse(raw);
        } catch {
          content = raw;
        }
        if (typeof content === "string" && content.startsWith("[error]")) {
          onError && onError(new Error(content));
          continue;
        }
        onDelta && onDelta(content);
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError(e);
  }
};
